export const blockIconsDeviceSettingsSuggest = (
	<span className='material-symbols-outlined'>settings_suggest</span>
);
